import { useCallback, useEffect, useState } from "react";
import { fetchPortfolioMetrics } from "../api/user";

export default function useFreeCash({ gameId = null, enabled = true } = {}) {
  const [freeCash, setFreeCash] = useState(null);

  const refreshFreeCash = useCallback(async () => {
    try {
      const payload = {};
      if (gameId) payload.game_id = gameId;
      const response = await fetchPortfolioMetrics(payload);
      const value = Number(response?.data?.data?.free_cash);
      if (Number.isFinite(value)) {
        setFreeCash(value);
      }
    } catch (error) {
      console.error("Error fetching free cash for order ticket:", error);
    }
  }, [gameId]);

  useEffect(() => {
    if (!enabled) return;
    refreshFreeCash();
  }, [enabled, refreshFreeCash]);

  return { freeCash, refreshFreeCash };
}
